
import React, { createContext, useEffect, useState } from 'react';
import { motion, useScroll, useSpring } from "framer-motion";
import Header from "./components/header/header";
import Navbar from "./components/nav/nav";
import Home from "./components/home/home";
import Qualification from './components/qualifications/qualifications'
import Projects from "./components/projects/projects";
import Contact from "./components/contact/contact";
import Footer from "./components/footer/footer";
import Dark from './components/dark/dark';
import ReactSwitch from 'react-switch';
import Earth from '../src/components/props/projects/earth.png';
import Moon from '../src/components/props/projects/moon.png';
import Sound from '../src/components/props/sound/click.mp3';


export const ThemeContext = createContext(null);

function WebContent() {
  // Get the theme preference from localStorage or use 'light' as the default value
  const initialTheme = localStorage.getItem('theme') || 'light';
  const [theme, setTheme] = useState(initialTheme);

  // Update the theme preference in localStorage and state
  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    localStorage.setItem('theme', newTheme);
    setTheme(newTheme);
    const audio = new Audio(Sound);
    audio.play(); // Play sound effect on checkedHandleIcon hover
  };

  // Scroll line
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });

  // Update the theme class on the HTML element when the theme changes
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);
  

  return (
    <>
      <ThemeContext.Provider value={{ theme, toggleTheme }}>
        <div id={theme}>
          <Dark />
          <motion.div className="progress-bar" style={{ scaleX }} />
          <div className="bg-circle1"></div>
          <div className="bg-circle2"></div>
          <div className="bg-circle3"></div>
          <div className="bg-circle4"></div>
          <Header />
          <div>
            <Navbar />
            <div className='switch'>
              <ReactSwitch
                onChange={toggleTheme}
                checked={theme === "dark"}
                offColor="#38aaff"
                onColor="#fce0a2"
                onHandleColor="#fce0a2"
                handleDiameter={30}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                height={20}
                width={60}
                uncheckedHandleIcon={
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '100%',
                      height: '100%',
                    }}
                  >
                    <img
                      src={Earth}
                      alt="Earth Icon"
                      style={{
                        width: '150%',
                        height: '150%',
                      }}
                      onMouseEnter={toggleTheme} // Play sound effect on mouse enter
                    />
                  </div>
                }
                checkedHandleIcon={
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      width: '100%',
                      height: '100%',
                    }}
                    onMouseEnter={toggleTheme} // Play sound effect on mouse enter
                  >
                    <img
                      src={Moon}
                      alt="Earth Icon"
                      style={{
                        width: '100%',
                        height: '100%',
                      }}
                    />
                  </div>
                }
              />
            </div>
            <div className={`dark-mode-toggle ${theme === 'dark' ? 'dark' : ''}`}>
            </div>
            <div>
              <Home />
              <Qualification />
              <Projects />
              <Contact />
            </div>
          </div>
          <Footer />
        </div>
      </ThemeContext.Provider>
    </>
  );
}

export default WebContent;
